import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function WPQTFilter({ children, title }) {
    return (_jsxs("div", { className: "wpqt-mb-6", children: [_jsx("div", { className: "wpqt-mb-2 wpqt-text-base", children: title }), _jsx("div", { className: "wpqt-flex wpqt-gap-2 wpqt-items-center", children: children })] }));
}
export { WPQTFilter };
